import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./input.css";
// import 'rsuite/dist/rsuite-no-reset.min.css';
import "react-datepicker/dist/react-datepicker.css";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import ProtectedRoute from "./routes/ProtectedRoute";
import UnprotectedRoute from "./routes/UnprotectedRoute";
import LoginRoute from "./routes/LoginRoute";
import { ToastContainer } from "react-toastify";
import Login from "./pages/Login";
import AcademicDashboard from "./pages/Academic/Dashboard";
import Academic from "./pages/Academic";
import Administrative from "./pages/Administrative";
import AdministrativeDashboard from "./pages/Administrative/Dashboard";
import AdministrativeFilials from "./pages/Settings/Filials";

import "react-toastify/dist/ReactToastify.css";
import AdministrativeGroups from "./pages/Settings/Groups";
import AdministrativeFilialTypes from "./pages/Settings/FilialTypes";
import AdministrativeParameters from "./pages/Settings/Parameters";
import InactivationOptions from "./pages/Settings/InactivationOptions";
import AdministrativeChartOfAccounts from "./pages/Financial/ChartOfAccounts";
import Languages from "./pages/Settings/Languages";
import ProgramCategory from "./pages/Settings/Program Category";
import Levels from "./pages/Settings/Levels";
import Page404 from "./pages/Errors/Page404";
import Errors from "./pages/Errors";
import LanguageMode from "./pages/Settings/Language Mode";
import Workloads from "./pages/Settings/Workloads";
import { injectStore } from "./services/api";
import AdministrativeUsers from "./pages/Settings/Users";
import Commercial from "./pages/Commercial";
import CommercialDashboard from "./pages/Commercial/Dashboard";
import CommercialProspects from "./pages/Commercial/Prospects";
import AdministrativeStudent from "./pages/Administrative/Student";
import Financial from "./pages/Financial";
import DSO from "./pages/DSO";
import Settings from "./pages/Settings";
import FinancialDashboard from "./pages/Financial/Dashboard";
import DSODashboard from "./pages/DSO/Dashboard";
import AdministrativeStaffs from "./pages/Administrative/Staffs";
import AdministrativePassFail from "./pages/Administrative/PassFail";
import FrequencyAdministrative from "./pages/Administrative/FrequencyAdministrative";
import AdministrativeAgents from "./pages/Commercial/Agents";
import AdministrativeCalendar from "./pages/Administrative/Calendar";
import AcademicCalendar from "./pages/Academic/Calendar";
import Documents from "./pages/Settings/Documents";
import HRRoot from "./pages/Administrative/HR";
import Outside from "./pages/Outside";
import PagePreviewOutside from "./pages/Administrative/Staffs/Preview/outside";
import Enrollments from "./pages/Commercial/Enrollments";
import EnrollmentOutside from "./pages/Commercial/Enrollments/Preview/enrollment";
import Error401 from "./pages/Errors/Page401";
import ProcessTypes from "./pages/Settings/ProcessTypes";
import ProcessSubstatuses from "./pages/Settings/ProcessSubstatuses";
import SponsorOutside from "./pages/Commercial/Enrollments/Preview/sponsor";
import TransferOutside from "./pages/Commercial/Enrollments/Preview/transfer-student";
import TransferDSOOutside from "./pages/Commercial/Enrollments/Preview/transfer-dso";
import FinancialBank from "./pages/Financial/Bank";
import FinancialBankAccounts from "./pages/Financial/BankAccount";
import FinancialPaymentMethods from "./pages/Financial/PaymentMethods";
import FinancialPaymentCriteria from "./pages/Financial/PaymentCriterias";
import FinancialSettlementTypes from "./pages/Financial/SettlementTypes";
import FinancialMerchants from "./pages/Financial/Merchants";
import FinancialHolds from "./pages/Financial/FinancialHolds";
import FinancialIssuers from "./pages/Financial/Issuer";
import FinancialReceivables, {
  FinancialInbounds,
} from "./pages/Financial/Inbounds/Receivables";
import FinancialPayees, {
  FinancialOutbounds,
} from "./pages/Financial/Outbounds/Payees";
import DataSync from "./pages/Settings/Data Sync";
import Tickets, { TicketsLayout } from "./pages/Settings/Tickets";
import TicketLevels from "./pages/Settings/Tickets/Levels";
import FinancialRecurrence from "./pages/Financial/Inbounds/Recurrence";
import FinancialGlobal from "./pages/Financial/Global";
import FinancialCollections, { CollectionsIndex, CollectionsSection } from "./pages/Financial/Collections";
import FinancialSettlement from "./pages/Financial/Inbounds/Settlement";
import PayeesRecurrence from "./pages/Financial/Outbounds/Recurrence";
import PayeesSettlement from "./pages/Financial/Outbounds/Settlement";
import FinancialDRE from "./pages/Financial/DRE";
import FinancialDRERegister from "./pages/Financial/DRE/Register";
import FinancialDREReport from "./pages/Financial/DRE/Report";
import Classrooms from "./pages/Administrative/Classroom";
import Studentgroups from "./pages/Administrative/Studentgroup";
import ResetPassword from "./pages/Auth/ResetPassword";
import Messages, { MessagesIndex } from "./pages/Administrative/Message";
import MessagingCatalog from "./pages/Administrative/Message/Catalog";
import DirectInbox from "./pages/Administrative/Message/DirectInbox";
import MedicalRequests from "./pages/Administrative/AbsenceExcuses";
import PartnersAndInfluencers from "./pages/Commercial/PartnersAndInfluencers";
import CostCenters from "./pages/Financial/CostCenters";
import I20Pendings from "./pages/DSO/I20 Pendings";
import CampaignRegistration from "./pages/Commercial/CampaignRegistration";
import ReportFinancialReceivables, {
  ReportFinancialInbounds,
} from "./pages/Reports/Financial/Receivables";
import ReportFinancialPayees from "./pages/Reports/Financial/Payees";
import ReportFinancialDelinquency from "./pages/Reports/Financial/Delinquency";
import ReportFinancialDelinquencyAging from "./pages/Reports/Financial/DelinquencyAging";
import Report from "./pages/Reports";
import ReportDashboard from "./pages/Reports/Dashboard";
import RotationOne from "./pages/Administrative/RotationOne";
import RotationTwo from "./pages/Administrative/RotationTwo";
import AdministrativeReports from "./pages/Administrative/Reports";
import CommercialExStudents from "./pages/Commercial/ExStudents";
import FinancialCashflow from "./pages/Financial/Cashflow";
import FinancialCashflowReport from "./pages/Financial/Cashflow/Report";
import FinancialCashflowRegister from "./pages/Financial/Cashflow/Register";
import Surveys, { SurveysRoot } from "./pages/Administrative/Surveys";
import SurveysConfiguration from "./pages/Administrative/SurveysConfiguration";
import EnrollmentSurveys from "./pages/Administrative/EnrollmentSurveys";
import Department from "./pages/Administrative/HR/Department";
import JobDescription from "./pages/Administrative/HR/JobDescription";
import EmployeeMovement from "./pages/Administrative/HR/EmployeeMovement";
import Timesheet from "./pages/Administrative/HR/Timesheet";
import TimesheetCreate from "./pages/Administrative/HR/Timesheet/Create";
import TimesheetReport from "./pages/Administrative/HR/Timesheet/Report";
import PreArrivals from "./pages/DSO/PreArrivals";
import Arrivals from "./pages/DSO/Arrivals";
import Orientation from "./pages/DSO/Orientation";
import BankConciliation, {
  FinancialConciliation,
} from "./pages/Financial/Conciliations/Bank Conciliation";
import GravityConciliation from "./pages/Financial/Conciliations/Gravity Conciliation";
import OtherConciliation from "./pages/Financial/Conciliations/Other Conciliation";

injectStore(store);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: (
      <main
        style={{
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <UnprotectedRoute>
          Error 404 <a href="/">home</a>
        </UnprotectedRoute>
      </main>
    ),
    children: [
      {
        path: "/login",
        element: (
          <LoginRoute>
            <Login />
          </LoginRoute>
        ),
      },
      {
        path: "/reset-password/:token",
        element: (
          <UnprotectedRoute>
            <ResetPassword />
          </UnprotectedRoute>
        ),
      },
      {
        path: "/fill-form",
        element: (
          <UnprotectedRoute>
            <Outside />
          </UnprotectedRoute>
        ),
        children: [
          {
            path: "/fill-form/Staff",
            element: <PagePreviewOutside />,
          },
          {
            path: "/fill-form/Enrollment",
            element: <EnrollmentOutside />,
          },
          {
            path: "/fill-form/Sponsor",
            element: <SponsorOutside />,
          },
          {
            path: "/fill-form/Transfer",
            element: <TransferOutside />,
          },
          {
            path: "/fill-form/TransferDSO",
            element: <TransferDSOOutside />,
          },
        ],
      },
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "/Administrative",
        element: (
          <ProtectedRoute>
            <Administrative />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Administrative/Dashboard",
            element: <AdministrativeDashboard />,
          },
          {
            path: "/Administrative/Calendar",
            element: <AdministrativeCalendar />,
          },
          {
            path: "/Administrative/Students",
            element: <AdministrativeStudent />,
          },
          {
            path: "/Administrative/Messages",
            element: <Messages />,
            children: [
              { index: true, element: <MessagesIndex /> },
              { path: "Templates", element: <MessagingCatalog kind="templates" /> },
              { path: "Campaigns", element: <MessagingCatalog kind="campaigns" /> },
              { path: "History", element: <MessagingCatalog kind="history" /> },
              { path: "QuickMessage", element: <DirectInbox /> },
            ],
          },
          {
            path: "/Administrative/HR",
            element: <HRRoot />,
            children: [
              {
                path: "/Administrative/HR/Department",
                element: <Department />,
              },
              {
                path: "/Administrative/HR/JobDescription",
                element: <JobDescription />,
              },
              {
                path: "/Administrative/HR/EmployeeMovement",
                element: <EmployeeMovement />,
              },
              {
                path: "/Administrative/HR/Timesheet",
                element: <Timesheet />,
              },
              {
                path: "/Administrative/HR/Report",
                element: <TimesheetReport />,
              },
              {
                path: "/Administrative/HR/Timesheet/Create/:id",
                element: <TimesheetCreate />,
              },
            ],
          },
          {
            path: "/Administrative/Staffs",
            element: <AdministrativeStaffs />,
          },
          {
            path: "/Administrative/Frequency",
            element: <FrequencyAdministrative />,
          },
          {
            path: "/Administrative/Surveys",
            element: <SurveysRoot />,
            children: [
              {
                path: "/Administrative/Surveys/Surveys",
                element: <Surveys />,
              },
              {
                path: "/Administrative/Surveys/Configuration",
                element: <SurveysConfiguration />,
              },
              {
                path: "/Administrative/Surveys/EnrollmentSurveys",
                element: <EnrollmentSurveys />,
              },
            ],
          },
          {
            path: "/Administrative/Classrooms",
            element: <Classrooms />,
          },
          {
            path: "/Administrative/StudentGroups",
            element: <Studentgroups />,
          },
          {
            path: "/Administrative/RotationFaseOne",
            element: <RotationOne />,
          },
          {
            path: "/Administrative/RotationFaseTwo",
            element: <RotationTwo />,
          },
          {
            path: "/Administrative/Reports",
            element: <AdministrativeReports />,
          },
          {
            path: "/Administrative/AbsenceExcuses",
            element: <MedicalRequests />,
          },
          {
            path: "/Administrative/*",
            element: <Page404 />,
          },
        ],
      },
      {
        path: "/Academic",
        element: (
          <ProtectedRoute>
            <Academic />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Academic/Dashboard",
            element: <AcademicDashboard />,
          },
          {
            path: "/Academic/Calendar",
            element: <AcademicCalendar />,
          },
          {
            path: "/Academic/PassFail",
            element: <AdministrativePassFail />,
          },
          {
            path: "/Academic/*",
            element: <Page404 />,
          },
        ],
      },
      {
        path: "/Commercial",
        element: (
          <ProtectedRoute>
            <Commercial />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Commercial/Dashboard",
            element: <CommercialDashboard />,
          },
          {
            path: "/Commercial/Prospects",
            element: <CommercialProspects />,
          },
          {
            path: "/Commercial/ExStudents",
            element: <CommercialExStudents />,
          },
          {
            path: "/Commercial/Enrollments",
            element: <Enrollments />,
          },
          {
            path: "/Commercial/Agents",
            element: <AdministrativeAgents />,
          },
          {
            path: "/Commercial/PartnersAndInfluencers",
            element: <PartnersAndInfluencers />,
          },
          {
            path: "/Commercial/Campaign",
            element: <CampaignRegistration />,
          },
        ],
      },
      {
        path: "/Financial",
        element: (
          <ProtectedRoute>
            <Financial />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Financial/Dashboard",
            element: <FinancialDashboard />,
          },
          {
            path: "/Financial/Bank",
            element: <FinancialBank />,
          },
          {
            path: "/Financial/BankAccount",
            element: <FinancialBankAccounts />,
          },
          {
            path: "/Financial/PaymentCriteria",
            element: <FinancialPaymentCriteria />,
          },
          {
            path: "/Financial/PaymentMethod",
            element: <FinancialPaymentMethods />,
          },
          {
            path: "/Financial/SettlementTypes",
            element: <FinancialSettlementTypes />,
          },
          {
            path: "/Financial/Merchants",
            element: <FinancialMerchants />,
          },
          {
            path: "/Financial/FinancialHolds",
            element: <FinancialHolds />,
          },
          {
            path: "/Financial/CostCenters",
            element: <CostCenters />,
          },
          {
            path: "/Financial/ChartOfAccounts",
            element: <AdministrativeChartOfAccounts />,
          },
          {
            path: "/Financial/Issuer",
            element: <FinancialIssuers />,
          },
          {
            path: "/Financial/Global",
            element: <FinancialGlobal />,
          },
          {
            path: "/Financial/Collections",
            element: <FinancialCollections />,
            children: [
              { index: true, element: <CollectionsIndex /> },
              { path: "Templates", element: <CollectionsSection kind="templates" /> },
              { path: "Campaigns", element: <CollectionsSection kind="campaigns" /> },
              { path: "History", element: <CollectionsSection kind="history" /> },
            ],
          },
          {
            path: "/Financial/Receivables",
            element: <FinancialInbounds />,
            children: [
              {
                path: "/Financial/Receivables/Receivables",
                element: <FinancialReceivables />,
              },
              {
                path: "/Financial/Receivables/Recurrence",
                element: <FinancialRecurrence />,
              },
              {
                path: "/Financial/Receivables/Settlement",
                element: <FinancialSettlement />,
              },
            ],
          },
          {
            path: "/Financial/Payees",
            element: <FinancialOutbounds />,
            children: [
              {
                path: "/Financial/Payees/Payees",
                element: <FinancialPayees />,
              },
              {
                path: "/Financial/Payees/Recurrence",
                element: <PayeesRecurrence />,
              },
              {
                path: "/Financial/Payees/Settlement",
                element: <PayeesSettlement />,
              },
            ],
          },
          {
            path: "/Financial/Conciliation",
            element: <FinancialConciliation />,
            children: [
              {
                path: "/Financial/Conciliation/Bank",
                element: <BankConciliation />,
              },
              {
                path: "/Financial/Conciliation/Gravity",
                element: <GravityConciliation />,
              },
              {
                path: "/Financial/Conciliation/Other",
                element: <OtherConciliation />,
              },
            ],
          },
          {
            path: "/Financial/IS",
            element: <FinancialDRE />,
            children: [
              {
                path: "/Financial/IS/Register",
                element: <FinancialDRERegister />,
              },
              {
                path: "/Financial/IS/Report",
                element: <FinancialDREReport />,
              },
            ],
          },
          {
            path: "/Financial/Cashflow",
            element: <FinancialCashflow />,
            children: [
              {
                path: "/Financial/Cashflow/Register",
                element: (
                  <FinancialCashflowRegister></FinancialCashflowRegister>
                ),
              },
              {
                path: "/Financial/Cashflow/Report",
                element: <FinancialCashflowReport></FinancialCashflowReport>,
              },
            ],
          },
        ],
      },
      {
        path: "/DSO",
        element: (
          <ProtectedRoute>
            <DSO />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/DSO/Dashboard",
            element: <DSODashboard />,
          },
          {
            path: "/DSO/Onboard Pendings",
            element: <I20Pendings />,
          },
          {
            path: "/DSO/PreArrivals",
            element: <PreArrivals />,
          },
          {
            path: "/DSO/Arrivals",
            element: <Arrivals />,
          },
          {
            path: "/DSO/Orientation",
            element: <Orientation />,
          },
        ],
      },
      {
        path: "/Settings",
        element: (
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Settings/Parameters",
            element: <AdministrativeParameters />,
          },
          {
            path: "/Settings/Languages",
            element: <Languages />,
          },
          {
            path: "/Settings/ProgramCategory",
            element: <ProgramCategory />,
          },
          {
            path: "/Settings/Levels",
            element: <Levels />,
          },
          {
            path: "/Settings/LanguageModes",
            element: <LanguageMode />,
          },
          {
            path: "/Settings/Workloads",
            element: <Workloads />,
          },
          {
            path: "/Settings/BranchesTypes",
            element: <AdministrativeFilialTypes />,
          },
          {
            path: "/Settings/Branches",
            element: <AdministrativeFilials />,
          },
          {
            path: "/Settings/InactivationOptions",
            element: <InactivationOptions />,
          },
          {
            path: "/Settings/Groups",
            element: <AdministrativeGroups />,
          },
          {
            path: "/Settings/Users",
            element: <AdministrativeUsers />,
          },
          {
            path: "/Settings/Documents",
            element: <Documents />,
          },
          {
            path: "/Settings/ProcessTypes",
            element: <ProcessTypes />,
          },
          {
            path: "/Settings/ProcessSubstatuses",
            element: <ProcessSubstatuses />,
          },
          {
            path: "/Settings/DataSync",
            element: <DataSync />,
          },
          {
            path: "/Settings/Tickets",
            element: <TicketsLayout />,
            children: [
              {
                path: "/Settings/Tickets/List",
                element: <Tickets />,
              },
              {
                path: "/Settings/Tickets/Levels",
                element: <TicketLevels />,
              },
            ],
          },
        ],
      },
      {
        path: "/Reports",
        element: (
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "/Reports/Dashboard",
            element: <ReportDashboard />,
          },
          {
            path: "/Reports/Financial",
            element: <ReportFinancialInbounds />,
            children: [
              {
                path: "/Reports/Financial/Receivables",
                element: <ReportFinancialReceivables />,
              },
              {
                path: "/Reports/Financial/Payees",
                element: <ReportFinancialPayees />,
              },
              {
                path: "/Reports/Financial/Delinquency",
                element: <ReportFinancialDelinquency />,
              },
              {
                path: "/Reports/Financial/DelinquencyAging",
                element: <ReportFinancialDelinquencyAging />,
              },
            ],
          },
        ],
      },
      {
        path: "/401",
        element: (
          <UnprotectedRoute>
            <Error401 />
          </UnprotectedRoute>
        ),
      },
      {
        path: "/404",
        element: (
          <UnprotectedRoute>
            <Page404 />
          </UnprotectedRoute>
        ),
      },
      {
        path: "/*",
        element: (
          <UnprotectedRoute>
            <Errors>
              <Page404 />
            </Errors>
          </UnprotectedRoute>
        ),
      },
    ],
  },
]);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
      </PersistGate>
      <ToastContainer autoClose={2500} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
